<app-nav-header></app-nav-header>
<div class="wrapper">
	<div class="main">
		<div id="homePage">
			<div class="aboutKYArea">
				<div class="bannerArea">
					<div class="animationBox">
						<img
							class="animationLogo"
							src="/assets/images/indexPage/hero-animation-logo.webp"
							alt=""
						/>
					</div>
					<div class="banner">
						<div
							class="titleBox"
							[ngClass]="{ 'titleBox-english': isEnglish() }"
						>
							<h1>
								{{ 'homePage.hero.title' | translate }}
								<br />
								<br *ngIf="isEnglish()" />
								{{ 'homePage.hero.subtitle' | translate }}
							</h1>
						</div>
						<div
							*ngIf="!isEnglish()"
							class="carouselBox"
						>
							<div class="swipeBox">
								<div class="swiper-interact">
									<div class="ctr">
										<div class="slide-idx">
											<span>0{{ carouselPageRef }}</span>
											<span class="post-fix">/05</span>
										</div>
										<div class="scroll">
											<div class="swiper-scrollbar-hero"></div>
										</div>
										<div class="action">
											<button
												class="swiper-button-prev"
												aria-label="前一頁"
											></button>
											<button
												class="swiper-button-next"
												aria-label="下一頁"
											></button>
										</div>
									</div>
								</div>
								<ng-container *ngIf="showSwiper">
									<swiper
										#heroSwiper
										[slidesPerView]="slidesPerView"
										[speed]="500"
										[spaceBetween]="35"
										[scrollbar]="{
											el: '.swiper-scrollbar-hero'
										}"
										[navigation]="{
											nextEl: '.swiper-button-next',
											prevEl: '.swiper-button-prev'
										}"
										[autoplay]="{
											delay: 5000,
											disableOnInteraction: false
										}"
										[centeredSlides]="true"
									>
										<ng-container *ngFor="let news of this.highlightNews">
											<ng-template swiperSlide>
												<div class="info-card">
													<div class="slide-info">
														<!-- <span>{{ news.HighlightSlogan }}</span> -->
														<time>{{ news.Date }}</time>
														<h2>
															{{ news.Content }}
														</h2>
														<div class="tagsBox">
															<p
																class="tag"
																*ngFor="let tag of news.Tags"
															>
																{{ tag }}
															</p>
														</div>
														<a
															[href]="goViewNews(news.TypeEN, news.FileTitle)"
															[title]="'前往' + news.Content"
														>
															深入瞭解 &nbsp;
															<i
																class="fa fa-arrow-right"
																aria-hidden="true"
															></i>
														</a>
													</div>
													<div class="imgBox">
														<img
															[src]="news.Image"
															alt=""
														/>
													</div>
												</div>
											</ng-template>
										</ng-container>
									</swiper>
								</ng-container>
							</div>
						</div>
					</div>
				</div>
			</div>

			<app-statistics></app-statistics>

			<div class="securityArea">
				<div class="securityBox securityBoxTab">
					<div class="pyramid">
						<img
							#pyramidPic
							src="/assets/images/indexPage/pyramid-1024-nation.webp"
							alt=""
						/>
					</div>
					<div class="narrative">
						<h2>{{ securityTitle }}</h2>
						<p-tabView
							(onChange)="onTabChange($event)"
							[(activeIndex)]="tabIdx"
						>
							<p-tabPanel [header]="'homePage.security.nationalSecurity.tab' | translate">
								<ng-container *ngTemplateOutlet="nationTpl"></ng-container>
							</p-tabPanel>
							<p-tabPanel [header]="'homePage.security.informationSecurity.tab' | translate">
								<ng-container *ngTemplateOutlet="infoTpl"></ng-container>
							</p-tabPanel>
							<p-tabPanel [header]="'homePage.security.publicSecurity.tab' | translate">
								<ng-container *ngTemplateOutlet="orderTpl"></ng-container>
							</p-tabPanel>
						</p-tabView>
					</div>
				</div>

				<div class="securityBox securityBoxSwiper">
					<swiper
						#securitySwiper
						[slidesPerView]="1"
						[speed]="500"
						[spaceBetween]="140"
						[initialSlide]="0"
						[navigation]="{
							nextEl: '.swiper-button-next-security',
							prevEl: '.swiper-button-prev-security'
						}"
					>
						<ng-template swiperSlide>
							<div class="info-card-security">
								<h2>
									{{ 'homePage.security.title' | translate }}
								</h2>
								<div class="pyramid">
									<img
										#pyramidPic
										src="/assets/images/indexPage/pyramid-1024-nation.webp"
										alt="國安：構築精實的國防科技"
									/>
								</div>

								<div class="narrative">
									<ng-container *ngTemplateOutlet="nationTpl"></ng-container>
								</div>
							</div>
						</ng-template>
						<ng-template swiperSlide>
							<div class="info-card-security">
								<h2>
									{{ 'homePage.security.title' | translate }}
								</h2>
								<div class="pyramid">
									<img
										#pyramidPic
										src="/assets/images/indexPage/pyramid-1024-info.webp"
										alt="資安：建構堅實的安全基石"
									/>
								</div>

								<div class="narrative">
									<ng-container *ngTemplateOutlet="infoTpl"></ng-container>
								</div>
							</div>
						</ng-template>
						<ng-template swiperSlide>
							<div class="info-card-security">
								<h2>
									{{ 'homePage.security.title' | translate }}
								</h2>
								<div class="pyramid">
									<img
										#pyramidPic
										src="/assets/images/indexPage/pyramid-1024-order.webp"
										alt="治安：打造高效的治安管理"
									/>
								</div>

								<div class="narrative">
									<ng-container *ngTemplateOutlet="orderTpl"></ng-container>
								</div>
							</div>
						</ng-template>
					</swiper>

					<button
						class="swiper-button-prev-security"
						aria-label="前一頁"
					>
						<img
							src="/assets/images//indexPage/security-swiper-left-btn.svg"
							alt="上一頁按鈕"
						/>
					</button>
					<button
						class="swiper-button-next-security"
						aria-label="下一頁"
					>
						<img
							src="/assets/images//indexPage/security-swiper-right-btn.svg"
							alt="下一頁按鈕"
						/>
					</button>
				</div>
			</div>

			<div class="coreTechArea">
				<div class="coreTechBox">
					<div class="desc">
						<span>{{ 'homePage.coreTech.title' | translate }}</span>
						<h2>{{ 'homePage.coreTech.subtitle' | translate }}</h2>
					</div>
					<div class="coreStackBox">
						<div class="bigDataBox">
							<h3 class="">
								{{ 'homePage.coreTech.coreStack.bigData.title' | translate }}
							</h3>
							<p>
								{{ 'homePage.coreTech.coreStack.bigData.content' | translate }}
							</p>
						</div>
						<div class="iotBox">
							<h3 class="">
								{{ 'homePage.coreTech.coreStack.iot.title' | translate }}
							</h3>
							<p>
								{{ 'homePage.coreTech.coreStack.iot.content' | translate }}
							</p>
						</div>
						<div class="aiBox">
							<h3 class="">
								{{ 'homePage.coreTech.coreStack.ai.title' | translate }}
							</h3>
							<p>
								{{ 'homePage.coreTech.coreStack.ai.content' | translate }}
							</p>
						</div>
						<div class="infoSecBox">
							<h3 class="">
								{{ 'homePage.coreTech.coreStack.infoSecurity.title' | translate }}
							</h3>
							<p>
								{{ 'homePage.coreTech.coreStack.infoSecurity.content' | translate }}
							</p>
						</div>
					</div>
				</div>
			</div>

			<div class="solutionArea">
				<div class="solutionBox">
					<div class="narrativeBox">
						<div class="narrativeNestedBox">
							<span>{{ 'homePage.narrativeNested.subtitle' | translate }}</span>
							<h2>
								{{ 'homePage.narrativeNested.title' | translate }}
							</h2>
							<p>
								{{ 'homePage.narrativeNested.content' | translate }}
							</p>

							<button
								class="view-btn"
								(click)="router.navigateByUrl('solutions')"
							>
								<span>{{ 'homePage.narrativeNested.button' | translate }}</span>
								<i
									class="fa fa-arrow-right"
									aria-hidden="true"
								></i>
							</button>
						</div>
					</div>
					<div class="solutionSwiperBox">
						<div class="swiper-pagination-solution"></div>
						<swiper
							[speed]="500"
							[loop]="true"
							[centeredSlides]="true"
							[observeParents]="true"
							[pagination]="{
								el: '.swiper-pagination-solution',
								clickable: true
							}"
							[autoplay]="{
								delay: 5000,
								disableOnInteraction: false
							}"
						>
							<ng-template swiperSlide>
								<div class="solutionCard">
									<ng-container *ngTemplateOutlet="orgTpl"></ng-container>
								</div>
							</ng-template>
							<ng-template swiperSlide>
								<div class="solutionCard">
									<ng-container *ngTemplateOutlet="transportTpl"></ng-container>
								</div>
							</ng-template>
							<ng-template swiperSlide>
								<div class="solutionCard">
									<ng-container *ngTemplateOutlet="educationTpl"></ng-container>
								</div>
							</ng-template>
							<ng-template swiperSlide>
								<div class="solutionCard">
									<ng-container *ngTemplateOutlet="industryTpl"></ng-container>
								</div>
							</ng-template>
						</swiper>
					</div>

					<div class="solutionGridBox">
						<div class="solutionCard solutionGridCard">
							<ng-container *ngTemplateOutlet="orgTpl"></ng-container>
						</div>
						<div class="solutionCard solutionGridCard">
							<ng-container *ngTemplateOutlet="transportTpl"></ng-container>
						</div>
						<div class="solutionCard solutionGridCard">
							<ng-container *ngTemplateOutlet="educationTpl"></ng-container>
						</div>
						<div class="solutionCard solutionGridCard">
							<ng-container *ngTemplateOutlet="industryTpl"></ng-container>
						</div>
					</div>
				</div>
			</div>

			<div class="collabArea">
				<div class="collabBox">
					<div class="collabThumbs">
						<h2>
							{{ 'homePage.collabThumbs.partners.title' | translate }}
						</h2>

						<swiper
							[spaceBetween]="0"
							[slidesPerView]="2"
							[allowTouchMove]="false"
						>
							<ng-template swiperSlide>
								<span
									(click)="
										collabSwiper?.swiperRef.slideTo(0);
										accEnterpriseIndex = -1;
										accPoliticalIndex = -1
									"
									[ngClass]="{
										activeSlide: collabSwiper?.swiperRef?.activeIndex === 0
									}"
								>
									{{ 'homePage.collabThumbs.partners.tabs.government' | translate }}
								</span>
							</ng-template>
							<ng-template swiperSlide>
								<span
									(click)="
										collabSwiper.swiperRef.slideTo(1);
										accEnterpriseIndex = -1;
										accPoliticalIndex = -1
									"
									[ngClass]="{
										activeSlide: collabSwiper?.swiperRef?.activeIndex === 1
									}"
								>
									{{ 'homePage.collabThumbs.partners.tabs.business' | translate }}
								</span>
							</ng-template>
						</swiper>
					</div>

					<div class="collabSwiperBox">
						<swiper
							#collabSwiper
							[thumbs]="{ swiper: thumbsSwiperRelation }"
							[slidesPerView]="1"
							[spaceBetween]="50"
							[speed]="200"
							[allowTouchMove]="false"
						>
							<!-- ----------------------------------------------------------------------- -->
							<!--                                  政府機構                                 -->
							<!-- ----------------------------------------------------------------------- -->

							<ng-template swiperSlide>
								<div class="itemsCtn politicalBox">
									<div
										*ngFor="
											let governmentFrontItem of governmentFront;
											let governmentFrontIndex = index
										"
										class="item"
									>
										<img
											src="../../../assets/images/indexPage/relationship/{{
												governmentFrontItem.Type
											}}/{{
												governmentFrontItem.Type +
													'-' +
													governmentFrontItem.Sort +
													'-' +
													governmentFrontIndex
											}}.png"
											alt="{{
												isEnglish() ? governmentFrontItem.NameEn : governmentFrontItem.Name
											}}"
											width="60"
										/>
										<!-- <p>
                                            {{
                                                isEnglish()
                                                    ? governmentFrontItem.NameEn
                                                    : governmentFrontItem.Name
                                            }}
                                        </p> -->
									</div>
								</div>
								<div class="moreBox">
									<p-accordion
										[(activeIndex)]="accPoliticalIndex"
										[expandIcon]="'pi pi-angle-down'"
										[collapseIcon]="'pi pi-angle-up'"
									>
										<p-accordionTab
											[header]="
												accPoliticalIndex === -1 || accPoliticalIndex === null
													? ('homePage.collabThumbs.partners.moreBtns.government' | translate)
													: ('homePage.collabThumbs.partners.moreBtns.collapse' | translate)
											"
										>
											<div class="itemsCtn">
												<div
													*ngFor="
														let governmentBackItem of governmentBack;
														let governmentBackIndex = index
													"
													class="item"
												>
													<img
														src="../../../assets/images/indexPage/relationship/{{
															governmentBackItem.Type
														}}/{{
															governmentBackItem.Type +
																'-' +
																governmentBackItem.Sort +
																'-' +
																governmentBackIndex
														}}.png"
														alt="{{
															isEnglish()
																? governmentBackItem.NameEn
																: governmentBackItem.Name
														}}"
														width="60"
													/>
													<!-- <p>
                                                        {{
                                                            isEnglish()
                                                                ? governmentBackItem.NameEn
                                                                : governmentBackItem.Name
                                                        }}
                                                    </p> -->
												</div>
											</div>
										</p-accordionTab>
									</p-accordion>
								</div>
							</ng-template>

							<!-- ----------------------------------------------------------------------- -->
							<!--                                  企業客戶                                 -->
							<!-- ----------------------------------------------------------------------- -->

							<ng-template swiperSlide>
								<div class="itemsCtn enterpriseBox">
									<div
										*ngFor="
											let enterpriseFrontItem of enterpriseFront;
											let enterpriseFrontIndex = index
										"
										class="item"
									>
										<img
											src="../../../assets/images/indexPage/relationship/{{
												enterpriseFrontItem.Type
											}}/{{
												enterpriseFrontItem.Type +
													'-' +
													enterpriseFrontItem.Sort +
													'-' +
													enterpriseFrontIndex
											}}.png"
											alt="{{
												isEnglish() ? enterpriseFrontItem.NameEn : enterpriseFrontItem.Name
											}}"
											width="60"
										/>
										<!-- <p>
                                            {{
                                                isEnglish()
                                                    ? enterpriseFrontItem.NameEn
                                                    : enterpriseFrontItem.Name
                                            }}
                                        </p> -->
									</div>
								</div>
								<div class="moreBox">
									<p-accordion
										#politicalTab
										[(activeIndex)]="accEnterpriseIndex"
										[expandIcon]="'pi pi-angle-down'"
										[collapseIcon]="'pi pi-angle-up'"
									>
										<p-accordionTab
											[header]="
												accEnterpriseIndex === -1 || accEnterpriseIndex === null
													? ('homePage.collabThumbs.partners.moreBtns.business' | translate)
													: ('homePage.collabThumbs.partners.moreBtns.collapse' | translate)
											"
										>
											<div class="itemsCtn">
												<div
													*ngFor="
														let enterpriseBackItem of enterpriseBack;
														let enterpriseBackIndex = index
													"
													class="item"
													[ngStyle]="
														enterpriseBackIndex === 9
															? { display: 'none' }
															: { display: 'unset' }
													"
												>
													<img
														src="../../../assets/images/indexPage/relationship/{{
															enterpriseBackItem.Type
														}}/{{
															enterpriseBackItem.Type +
																'-' +
																enterpriseBackItem.Sort +
																'-' +
																enterpriseBackIndex
														}}.png"
														alt="{{
															isEnglish()
																? enterpriseBackItem.NameEn
																: enterpriseBackItem.Name
														}}"
														width="60"
													/>
													<!-- <p>
                                                        {{
                                                            isEnglish()
                                                                ? enterpriseBackItem.NameEn
                                                                : enterpriseBackItem.Name
                                                        }}
                                                    </p> -->
												</div>
											</div>
										</p-accordionTab>
									</p-accordion>
								</div>
							</ng-template>
						</swiper>
					</div>
				</div>
			</div>
			<app-partnership></app-partnership>
		</div>
	</div>
</div>
<app-footer></app-footer>

<!-- ** 三安 金字塔 -->
<ng-template #pyramidTpl></ng-template>

<!-- ** 三安 文字描述 -->

<ng-template #nationTpl>
	<p>
		{{ 'homePage.security.nationalSecurity.content' | translate }}
	</p>
</ng-template>

<ng-template #infoTpl>
	<p>
		{{ 'homePage.security.informationSecurity.content' | translate }}
	</p>
</ng-template>

<ng-template #orderTpl>
	<p>
		{{ 'homePage.security.publicSecurity.content' | translate }}
	</p>
</ng-template>

<!-- ** 解決方案 -->
<ng-template #orgTpl>
	<img
		src="/assets/images/indexPage/solution-military-unit.webp"
		alt=""
	/>
	<div class="strip">
		<span>{{ 'homePage.narrativeNested.strip.military' | translate }}</span>
	</div>
</ng-template>

<ng-template #transportTpl>
	<img
		src="/assets/images/indexPage/solution-police-agency.webp"
		alt=""
	/>
	<div class="strip">
		<span>{{ 'homePage.narrativeNested.strip.police' | translate }}</span>
	</div>
</ng-template>

<ng-template #educationTpl>
	<img
		src="/assets/images/indexPage/solution-prosecutorial-and-judicial-authorities.webp"
		alt=""
	/>
	<div class="strip">
		<span>{{ 'homePage.narrativeNested.strip.prosecutorial' | translate }}</span>
	</div>
</ng-template>

<ng-template #industryTpl>
	<img
		src="/assets/images/indexPage/solution-transportation-and-logistics.webp"
		alt=""
	/>
	<div class="strip">
		<span>{{ 'homePage.narrativeNested.strip.logistics' | translate }}</span>
	</div>
</ng-template>
